import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import qs from 'qs'
import { defaultInstance } from 'services'
import { removeEmpty } from 'utils'
import { responseSuccess, responseError } from 'utils/response'


export const postReportAttachmentApi = (files,{ report_header_id, report_task_id,report_attribute_value_id }) => {
  const params = removeEmpty({ report_header_id,report_task_id,report_attribute_value_id })

  const formData = new FormData()
  console.log("AS",files)
  _.map(files,(item)=>{
    formData.append('upload_files', item)
  })
   

  const config = {
    method: 'post',
    url: '/api/v1/report_attachment',
    data:formData,
    params,
  }
  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      return responseError({ message: err.message })
    })
}

export const getReportAttachmentApi = ({report_header_id, report_task_id,report_attribute_value_id }) => {
  const params = removeEmpty({ report_header_id,report_task_id,report_attribute_value_id })

  const config = {
    method: 'get',
    url: '/api/v1/report_attachment',
    params,
  }
  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      return responseError({ message: err.message })
    })
}

export const deleteReportAttachmentApi = (files_id) => {
  const params = removeEmpty({ files_id})

  const config = {
    method: 'delete',
    url: '/api/v1/report_attachment',
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
  }
  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      return responseError({ message: err.message })
    })
}
